export enum questionnairesPageActionTypes {
  SET_QUESTIONNAIRES_FILTERS = 'SET_QUESTIONNAIRES_FILTERS',
}
